import React, { useMemo } from 'react';
import OrganizationAnalyticsLineChart from './OrganizationAnalyticsLineChart';
import { formatTimeCategoriesByRange, mapIdsToLabels } from './chartUtils';

const OrganizationInfluencerSpendersByTimeChart = ({ data, influencerLabelMap, dateRange, pending }) => {
  const { categories, series } = useMemo(
    () => ({
      categories: formatTimeCategoriesByRange(data?.time || [], dateRange),
      series: (data?.series || []).map(item => ({
        name: mapIdsToLabels([item.influencerId], influencerLabelMap)[0],
        data: item.spenders || [],
      })),
    }),
    [data, influencerLabelMap, dateRange],
  );

  return (
    <OrganizationAnalyticsLineChart
      title="Spenders Over Time"
      subtitle="New spending users over time per creator."
      categories={categories}
      series={series}
      pending={pending}
      emptyText="Select one or more creators to load spenders over time."
      valueType="number"
    />
  );
};

export default OrganizationInfluencerSpendersByTimeChart;
